import {
    classification,
    component, component_product,
    componentDlCl,
    file,
    filters,
    folder,
    manufacturer,
    newComponent, paramsRawMaterials,
    product,
    rawMaterial
} from './state';

/**
 * Establecer un valor para product.
 */
export function setProduct(state, product) {
    state.product = product;
}

/**
 * Restablecer el valor por defecto de product.
 */
export function resetProduct(state) {
    state.product = product();
}

/**
 * Restablecer el valor por defecto de raw_material.
 */
export function resetRawMaterial(state) {
    state.raw_material = rawMaterial();
}

/**
 * Restablecer un valor para raw_material.
 */
export function setRawMaterial(state, raw_material) {
    state.raw_material = raw_material;
}

/**
 * Establecer un valor para products.
 */
export function setProducts(state, products) {
    state.products = products;
}

/**
 * Establecer un valor para raw_materials.
 */
export function setRawMaterials(state, raw_materials) {
    state.raw_materials = raw_materials;
}

/**
 * Establecer un valor para manufacturers.
 */
export function setManufacturers(state, manufacturers) {
    state.manufacturers = manufacturers;
}

/**
 * Establecer un valor para manufacturers.
 */
export function setManufacturersFilters(state, manufacturers_filters) {
    state.manufacturers_filters = manufacturers_filters;
}

/**
 * Restablecer el valor por defecto de filters.
 */
export function resetFilters(state) {
    state.products = {data: []};
    state.filters = filters();
}

/**
 * Restablecer el valor por defecto para el atributo page de filters.
 */
export function resetPageFilters(state) {
    state.filters.page = 1;
}

/**
 * Establecer un valor para el atributo show page de modal.
 */
export function setModalShow(state, show) {
    state.modal.show = show;
}

/**
 * Establecer un valor para el atributo show de la variable modal.
 */
export function setShowToModal(state, show) {
    state.modal.show = show;
}

/**
 * Establecer un valor para action_raw_material.
 */
export function setActionRawMaterialShow(state, action_raw_material) {
    state.action_raw_material = action_raw_material;
}

/**
 * Establecer un valor para el atributo show page de modal_raw_material.
 */
export function setModalRawMaterialShow(state, show) {
    state.modal_raw_material.show = show;
    state.raw_material = rawMaterial();
}

/**
 * Establecer un valor para el atributo show page de modal_components.
 */
export function setModalComponentsShow(state, show) {
    state.modal_components.show = show;
}

/**
 * Establecer un valor para el atributo show page de modal_component.
 */
export function setModalComponentShow(state, show) {
    state.modal_component.show = show;
}

/**
 * Establecer un valor para el atributo show page de modal_component.
 */
export function setModalNewComponentShow(state, show) {
    state.modal_new_component.show = show;
}

/**
 * Establecer un valor para companies.
 */
export function setCompaniesFilters(state, companies_filters) {
    state.companies_filters = companies_filters;
}

/**
 * Establecer un valor para el atributo company_id page de filters.
 */
export function setCompanyIdFilter(state, company_id) {
    state.filters.company_id = company_id;
}

/**
 * Establecer un valor para el atributo paginate page de filters.
 */
export function setPaginateFilter(state, paginate) {
    state.filters.paginate = paginate;
}


/**
 * Establecer un valor para el atributo slq_company_id page de product.
 */
export function setCompanyIdProduct(state) {
    if (!state.product.slq_company_id) {
        state.product.slq_company_id = state.filters.company_id;
    }
}

/**
 * Establecer un valor para el atributo slq_company_id page de raw_material.
 */
export function setCompanyIdRawMaterial(state) {
    state.raw_material.slq_company_id = state.product.slq_company_id;
}

/**
 * Establecer un valor para el atributo slq_company_id page de component.
 */
export function setCompanyIdToNewComponent(state) {
    state.new_component.slq_company_id = state.product.slq_company_id;
}

/**
 * Establecer un valor para categories.
 */
export function setCategories(state, categories) {

    let temp_categories = [];

    temp_categories.push({label: 'Ambientales', options: []});

    categories.ambiental.map(i => temp_categories[0].options.push(i));

    temp_categories.push({label: 'Físicos', options: []});

    categories.fisicos.map(i => temp_categories[1].options.push(i));

    temp_categories.push({label: 'Peligrosos', options: []});

    categories.peligrosas.map(i => temp_categories[2].options.push(i));

    temp_categories.push({label: 'Salud', options: []});

    categories.salud.map(i => temp_categories[3].options.push(i));

    state.categories = temp_categories;
}

/**
 * Establecer un valor para components.
 */
export function setComponents(state, components) {
    state.components = components;
}

/**
 * Restablecer el valor por defecto de new_component.
 */
export function resetNewComponent(state) {
    state.new_component = newComponent();
}

/**
 * Restablecer el valor por defecto de component.
 */
export function resetComponent(state) {
    state.component = component();
}

/**
 * Establecer un valor para el atributo slq_company_id page de component.
 */
export function setCompanyIdNewComponent(state) {
    state.new_component.slq_company_id = state.product.slq_company_id;
}

/**
 * Establecer un valor para el atributo cal_component_id page de component.
 */
export function setCalComponentIdComponent(state, cal_component_id) {
    state.component.pivot.cal_component_id = cal_component_id;
}

/**
 * Establecer un valor para la variable new_component.
 */
export function setNewComponent(state, new_component) {

    let sga_categories = [];

    if (new_component.sga) {
        new_component.sga.map(c => sga_categories.push(c.slq_sga_category_id));
    }

    new_component.sga_categories = sga_categories;

    state.new_component = JSON.parse(JSON.stringify(new_component));
}

/**
 * Establecer un valor para la variable action.
 */
export function setAction(state, action) {
    state.action = action;
}

/**
 * Establecer un valor para la variable action_new_component.
 */
export function setActionNewComponent(state, action_new_component) {
    state.action_new_component = action_new_component;
}

/**
 * Agregar un componente al array de componentes.
 */
export function addComponent(state) {

    let component_index = -1;

    if (state.raw_material.components) {
        component_index = state.raw_material.components.findIndex(c => c.pivot.cal_component_id === state.component.pivot.cal_component_id);
    } else {
        state.raw_material.components = [];
    }

    const component = state.components.find(c => c.id === state.component.pivot.cal_component_id);

    state.component.code_cas = component.code_cas;
    state.component.name = component.name;
    state.component.pivot.final_percentage = state.component.pivot.reported_percentage * state.raw_material.percentage / 100;

    if (component_index >= 0) {
        state.raw_material.components.splice(component_index, 1, state.component);
    } else {
        state.raw_material.components.push(state.component);
    }
}

/**
 * Establecer un valor para la variable component.
 */
export function setComponent(state, component) {
    state.component = component;
}

/**
 * Agregar un componente al array de componentes.
 */
export function deleteComponent(state, component_id) {

    const component_index = state.raw_material.components.findIndex(c => c.pivot.cal_component_id === component_id);

    if (component_index >= 0) {
        state.raw_material.components.splice(component_index, 1);
    }
}

/**
 * Asignar un valor a la variable measure_units_cl_50.
 */
export function setMeasureUnitsCl50(state, measure_units_cl_50) {
    state.measure_units_cl_50 = measure_units_cl_50;
}

/**
 * Establecer un valor para el atributo show page de modal_dl_cl.
 */
export function setModalDlClShow(state, show) {
    state.modal_dl_cl.show = show;
}

/**
 * Establecer un valor para la variable component_dl_cl.
 */
export function setComponentDlCl(state, component_dl_cl) {

    if (!component_dl_cl.dl_cl) {
        component_dl_cl.dl_cl = componentDlCl().dl_cl;
    }

    state.component_dl_cl = component_dl_cl;
}

/**
 * Establecer un valor para la variable component.
 */
export function setQuestionGroups(state, question_groups) {
    for (let i = 0; i < question_groups.length; i++) {
        if (!!question_groups[i].questions.length) {
            question_groups[i].questions.map(q => {
                const answer = state.answers.find(a => a.cal_question_id === q.id);

                if (!!answer) {
                    if (q.type === 'check') {
                        q.answer = +answer.answer === 1;
                    } else if (q.type === 'check_tree') {
                        q.answer = answer.answer === null ? answer.answer : +answer.answer === 1;
                    } else {
                        q.answer = answer.answer;
                    }
                    q.has_answer = true;
                } else if (q.type === 'check' && state.set_answers) {
                    q.answer = false;
                    q.has_answer = false;
                }
            });
        }
    }

    state.question_groups = question_groups;
}

/**
 * Establecer un valor para la variable question_groups.
 */
export function setBasicQuestionGroups(state, question_groups) {
    state.question_groups = question_groups;
}

/**
 * Establecer un valor para la variable component.
 */
export function setAnswers(state, answers) {
    state.answers = answers;
}

/**
 * Limpiar respuestas
 */
export function clearAnswers(state, questions_index) {
    state.question_groups.map((qg, i) => {
        if (i > questions_index) {
            qg.questions.map(q => {
                if (q.type === 'check') {
                    q.answer = null;
                }
            });
        }
    });
}

/**
 * Establecer un valor para la variable module_code.
 */
export function setModuleCode(state, module_code) {
    state.module_code = module_code;
}

/**
 * Establecer un valor para la variable components_iarc.
 */
export function setComponentsIarc(state, components_iarc) {
    state.components_iarc = components_iarc;
}

/**
 * Establecer un valor para la variable set_answers.
 */
export function setSetAnswers(state, set_answers) {
    state.set_answers = set_answers;
}

/**
 * Establecer un valor para la variable modal_definitions.
 */
export function setModalDefinitions(state, definitions) {
    state.definitions = definitions;
    state.modal_definitions.show = !state.modal_definitions.show;
}

/**
 * Establecer un valor para la variable danger_classes.
 */
export function setDangerClasses(state, danger_classes) {
    state.danger_classes = danger_classes;
}

/**
 * Establecer un valor para la variable danger_categories.
 */
export function setDangerCategories(state, danger_categories) {
    state.danger_categories = danger_categories;
}

/**
 * Establecer un valor para la variable modules.
 */
export function setModules(state, modules) {
    state.modules = modules;
}

/**
 * Establecer un valor para la variable pictograms.
 */
export function setPictograms(state, pictograms) {
    state.pictograms = pictograms;
}

/**
 * Establecer un valor para la variable classification.
 */
export function setClassification(state, payload) {
    if (payload) {
        state.classification = payload;
    } else {
        state.classification = classification();
    }
}

/**
 * Establecer el valor por defecto de la variable classification.
 */
export function resetClassification(state) {
    state.classification = classification();
}

/**
 * Establecer un valor para el atributo show de la variable modal_wizard.
 */
export function setShowToModalWizard(state, show) {
    state.modal_wizard.show = show;
}

/**
 * Establecer un valor para el atributo step de la variable modal_wizard.
 */
export function setStepToModalWizard(state, step) {
    state.modal_wizard.step = step;
}

/**
 * Establecer un valor para la variable only_view.
 */
export function setOnlyView(state, only_view) {
    state.only_view = only_view;
}

/**
 * Establecer un valor para la variable code_question_group.
 */
export function setCodeQuestionGroup(state, code_question_group) {
    state.code_question_group = code_question_group;
}

/**
 * Establecer un valor para la variable questions_index.
 */
export function setQuestionsIndex(state, questions_index) {
    state.questions_index = questions_index;
}

/**
 * Establecer un valor para la variable questions_index.
 */
export function setQuestionsIndexFromClassification(state) {
    state.questions_index = 0;

    if (state.classification) {
        state.questions_index = state.classification.index_questions;
    }
}

/**
 * Establecer un valor para la variable grouped_components.
 */
export function setGroupedComponents(state, grouped_components) {

    grouped_components.map(gc => {
        if (!gc.dl_cl) {
            gc.dl_cl = {
                active: 1,
                cal_component_id: gc.id,
                ce_50_crustaceans: null,
                cer_50_algae: null,
                cl_50_fish: null,
                cl_50_inhalation: null,
                cseo_algae: null,
                cseo_crustaceans: null,
                cseo_fish: null,
                dl_50_cutaneous: null,
                dl_50_oral: null,
                id: null,
                sys_measure_unit_cl_50_id: null,
            };
        }
    });

    state.grouped_components = grouped_components;
}

/**
 * Establecer un valor para la variable product_classifications.
 */
export function setProductClassifications(state, product_classifications) {
    product_classifications.grouped_classifications.map(d => {
        d.classifications.map(c => {
            c.image_pictogram = null;
            if (c.classification) {
                if (c.classification.pictogram) {
                    c.classification.image_pictogram = process.env.VUE_APP_API_URL + 'img/sga/pictogramas/' + c.pictogram.imagen;
                } else if (c.classification.sga_categories.length && c.classification.sga_categories[0].sga_category.pictogramas && c.classification.sga_categories[0].sga_category.pictogramas[0]) {
                    c.classification.image_pictogram = process.env.VUE_APP_API_URL + 'img/sga/pictogramas/' + c.classification.sga_categories[0].sga_category.pictogramas[0].imagen;
                }
            }
        });
    });

    state.product_classifications = product_classifications;
}

/**
 * Establecer un valor para la variable files.
 *
 * @param {Object} state - El estado actual del store de Vuex.
 * @param {Array} files - El nuevo valor para el atributo files.
 */
export function setFiles(state, files) {
    state.files = files;
}

/**
 * Establecer un valor para el atributo show de la variable modal_file.
 *
 * @param {Object} state - El estado actual del store de Vuex.
 * @param {boolean} show - El nuevo valor para el atributo show.
 */
export function setShowToModalFile(state, show) {
    state.modal_file.show = show;
}

/**
 * Establecer un valor para el atributo show de la variable modal_name.
 *
 * @param {Object} state - El estado actual del store de Vuex.
 * @param {boolean} show - El nuevo valor para el atributo show.
 */
export function setShowToModalName(state, show) {
    state.modal_name.show = show;
}

/**
 * Establecer el valor por defecto de la variable file.
 *
 * @param {Object} state - El estado actual del store de Vuex.
 */
export function resetFile(state) {
    state.file = file();
}

/**
 * Establecer un valor para la variable file.
 *
 * @param {Object} state - El estado actual del store de Vuex.
 * @param {Object|null} file - El nuevo valor para el atributo file.
 */
export function setFile(state, file) {
    state.file = file;
}

/**
 * Establecer un valor para la variable folder.
 *
 * @param {Object} state - El estado actual del store de Vuex.
 * @param {Object|null} folder - El nuevo valor para el atributo folder.
 */
export function setFolder(state, folder) {
    state.folder = folder;
}

/**
 * Establecer el valor por defecto de la variable folder.
 *
 * @param {Object} state - El estado actual del store de Vuex.
 */
export function resetFolder(state) {
    state.folder = folder();
}

/**
 * Establecer un valor para el atributo creating de la variable modal_name.
 *
 * @param {Object} state - El estado actual del store de Vuex.
 * @param {boolean} creating - El nuevo valor para el atributo creating.
 */
export function setCreatingToModalName(state, creating) {
    state.modal_name.creating = creating;
}

/**
 * Establecer un valor para el atributo show de la variable modal_preview.
 *
 * @param {Object} state - El estado actual del store de Vuex.
 * @param {boolean} show - El nuevo valor para el atributo show.
 */
export function setShowToModalPreview(state, show) {
    state.modal_preview.show = show;
}

/**
 * Establecer un valor para el atributo show de la variable modal_manufacturer.
 *
 * @param {Object} state - El estado actual del store de Vuex.
 * @param {boolean} show - El nuevo valor para el atributo show.
 */
export function setShowToModalManufacturer(state, show) {
    state.modal_manufacturer.show = show;
}

/**
 * Establecer el valor por defecto de la variable manufacturer.
 *
 * @param {Object} state - El estado actual del store de Vuex.
 */
export function resetManufacturer(state) {
    state.manufacturer = manufacturer();
}

/**
 * Establecer un valor para el atributo manufacturer de la variable product.
 *
 * @param {Object} state - El estado actual del store de Vuex.
 * @param {Object} manufacturer - El nuevo valor para el atributo manufacturer.
 */
export function setManufacturerToProduct(state, manufacturer) {
    state.product.prod_manufacturer_id = manufacturer.id;
    state.manufacturers = [manufacturer];
}

/**
 * Establecer un valor para la variable totals.
 */
export function setTotals(state, totals) {
    state.totals = totals;
}

/**
 * Establecer un valor para el atributo properties de la variable product.
 *
 * @param {Object} state - El estado actual del store de Vuex.
 * @param {Object} properties - El nuevo valor para el atributo properties.
 */
export function setPropertiesToProduct(state, properties) {
    state.product.properties = properties;
}

/**
 * Establecer un valor para el atributo cal_component_id de la variable component_product.
 */
export function setCalComponentIdToComponentProduct(state, cal_component_id) {
    state.component_product.cal_component_id = cal_component_id;
}

/**
 * Establecer un valor para el atributo cal_product_id de la variable component_product.
 */
export function setCalProductIdToComponentProduct(state, cal_product_id) {
    state.component_product.cal_product_id = cal_product_id;
}

/**
 * Establecer el valor por defecto de la variable component_product.
 */
export function resetComponentProduct(state) {
    state.component_product = component_product();
}

/**
 * Establecer un valor para la variable mode.
 */
export function setMode(state, mode) {
    state.mode = mode;
}

/**
 * Establecer un valor para el atributo show de la variable modal_converter.
 */
export function setShowToModalConverter(state, show) {
    state.modal_converter.show = show;
}

/**
 * Establecer un valor para el atributo show de la variable modal_raw_materials.
 */
export function setShowToModalRawMaterials(state, show) {
    state.modal_raw_materials.show = show;
}

/**
 * Establecer un valor para el atributo show de la variable modal_raw_material.
 */
export function setShowToModalRawMaterial(state, show) {
    state.modal_raw_material.show = show;
}

/**
 * Establecer el valor por defecto de la variable modal_raw_materials.
 */
export function resetParamsInModalRawMaterials(state) {
    state.modal_raw_materials.params = paramsRawMaterials();
}

/**
 * Establecer el valor por defecto de la variable modal_raw_materials.
 */
export function resetPageParamsInModalRawMaterials(state) {
    state.modal_raw_materials.params.page = 1;
}

/**
 * Establecer un valor para la variable filters.
 */
export function setFilters(state, filters) {
    state.filters = filters;
}

/**
 * Establecer un valor para la variable raw_material_temp.
 */
export function setRawMaterialTemp(state, raw_material_temp) {
    state.raw_material_temp = raw_material_temp;
}

/**
 * Establecer data de la variable product.
 */
export function setDataToProduct(state, data) {
    state.product.id = data.id;
    state.product.slq_company_id = data.slq_company_id;
}

/**
 * Agregar un componente a raw_material.
 */
export function addComponentToRawMaterial(state, component) {
    state.raw_material.raw_material.components_product.push(component);
}


/**
 * Agregar un componente a raw_material.
 */
export function updateComponentToRawMaterial(state, component) {
    state.raw_material.raw_material.components_product.map(cp => {
        if (cp.cal_component_id === component.id) {
            cp.component = component;
        }
    });
}

/**
 * Establecer un valor para el atributo action de la variable modal_raw_material.
 */
export function setActionToModalRawMaterial(state, action) {
    state.modal_raw_material.action = action;
}

/**
 * Eliminar un componente a raw_material.
 */
export function deleteComponentToRawMaterial(state, index) {
    state.raw_material.raw_material.components_product.splice(index, 1);
}

/**
 * Establecer un valor para el atributo action de la variable modal_new_component.
 */
export function setActionToModalNewComponent(state, action) {
    state.modal_new_component.action = action;
}

/**
 * Establecer un valor para el atributo name de la variable new_component.
 */
export function setNameToNewComponent(state, name) {
    state.new_component.name = name;
}
